import { render } from "./popup.vue?vue&type=template&id=82602c80&scoped=true&ts=true"
import script from "./popup.vue?vue&type=script&lang=ts"
export * from "./popup.vue?vue&type=script&lang=ts"

import "./popup.vue?vue&type=style&index=0&id=82602c80&scoped=true&lang=css"
import "./popup.vue?vue&type=style&index=1&id=82602c80&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82602c80"]])

export default __exports__